import { $axios } from 'src/boot/axios';
import generator from './generator';

const state = () => ({
  categories: undefined,
  templates: undefined,
  selectedCategory: undefined,
});

const actions = {
  async fetchTemplates({ commit }) {
    const { data } = await $axios.get('generator/templates');

    const templates = data.data.reduce((accumulator, template) => {
      if (accumulator[template.category.name]) {
        accumulator[template.category.name].templates.push(template);
      } else {
        accumulator[template.category.name] = {
          name: template.category.name,
          iconUrl: template.category.iconUrl,
          key: template.category.key,
          templates: [template],
        };
      }
      return accumulator;
    }, {});

    commit('setTemplates', Object.values(templates));
  },
  async fetchCategories({ commit }) {
    const { data } = await $axios.get('generator/templates/categories');
    commit('setCategories', data.data);
    return data.data;
  },
};

const mutations = {
  setTemplates(state, payload) {
    state.templates = payload;
  },
  setSelectedCategory(state, payload) {
    state.selectedCategory = payload;
  },
  setCategories(state, payload) {
    state.categories = payload;
  },
};

export default {
  namespaced: true,
  modules: {
    generator,
  },
  mutations,
  actions,
  state,
};
